import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiScaleControlComponent } from './ui-scale-control.component';

@NgModule({
  declarations: [UiScaleControlComponent],
  imports: [CommonModule],
  exports: [UiScaleControlComponent],
})
export class UiScaleControlModule {}
